import React from "react";
import Form from "./Form";
import Charts from "./Charts";
import { Link } from "react-router-dom";

const MainPage = () => {
  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Dashboard</h1>
        <Link to="/table" className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
          View Table
        </Link>
      </div>
      <Form />
      <Charts />
    </div>
  );
};

export default MainPage;
